<template>
  <div>
    <v-dialog v-model="dialog" width="500" >
      <v-sheet>
        <v-sheet>
          <v-container class="text-center">
            <v-form lazy-validation v-model="valid" ref="Form">
            <v-text-field
                label="Nazwa"
                type="Text"
                :min="0"
                :counter="32"
                v-model="name"
                :rules="nameRule"
            ></v-text-field>
            <v-text-field
                label="Opis"
                type="Text"
                :min="0"
                :counter="255"
                v-model="description"
                :rules="descriptionRule"
            ></v-text-field>
            <v-btn @click="submit()" color="green" >
              OK
            </v-btn>
            </v-form>
          </v-container>
        </v-sheet>
      </v-sheet>
    </v-dialog>

    <v-layout style="margin-bottom: 3rem" wrap>
      <v-flex  xs12 sm12 md8 lg8>
        <v-btn icon  color="none" :to="{ name : 'storage-products' }">
          <v-icon>arrow_left</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-btn @click="createNew()" color="green" >
      <v-icon>add</v-icon>
    </v-btn>

    <v-layout wrap>
      <v-flex  xs12 sm12 md8 lg8>
        <h2 style="display: block; margin-top: 1.5rem">Typy magazynów:</h2>
      </v-flex>
      <v-flex xs12 sm12 md4 lg4>
        <v-text-field @change="search($event)" label="Szukaj"></v-text-field>
      </v-flex>
    </v-layout>

    <v-data-table :loading ="loading" :headers=" headers" :items="products" class="elevation-10">
      <template v-slot:items="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.description }}</td>
        <td>
          <v-btn small icon>
            <v-icon color="primary"  fab block @click="prepareToUpdateProduct(props.item)">edit</v-icon>
          </v-btn>
          <v-btn small icon>
            <v-icon  fab block @click="deleteProduct(props.item.id)">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ItemForm from "@/components/storage/ItemForm";
import New from "@/components/storage/New";
import Messenger from "@/plugins/Messenger";
export default {
  name: "Index",
  components: {New, ItemForm},
  data(){
    return{
      dialogNewProduct:false,
      dialog: false,
      loading: false,
      updateItem : null,
      id :0,
      valid:false,
      name: '',
      description: '',
      nameRule: [v => !!v || "name is required", v => v.length <= 32 || "Max 32 characters",  ],
      descriptionRule: [v => !!v || "description is required", v => v.length <= 255 || "Max 55 characters",  ],
      products : [],
      allProducts : [],
      headers:[
        {
          text: 'ID',
          value: "id",
        },
        {
          text: this.$t('archive.name'),
          value: 'name'
        },
        {
          text: this.$t('department.description'),
          value: 'description'
        },
      ]
    }
  },
  methods:{
    createNew(){
      this.id = 0
      this.dialog = true
    },
    submit(){
      if(!this.valid){
        return
      }

      this.dialog = false
      if(this.id>0){
        return this.update()
      }

      this.create()

    },
    create(){
      this.$http.post('storage/type', {"name": this.name,"description": this.description}).then(data=>{
        Messenger.emitSuccess("Dodano produkt")
        this.allProducts.push(data.data)
        this.products = this.allProducts
        this.clear()
      }).catch(()=>{
        Messenger.emitError("Nie można dodać produktu produktu")
      })
    },
    update(){
      let postData = {
        'id' : this.id,
        'name' : this.name,
        'description' : this.description,
      }

      this.$http.put('storage/type/' + this.id, postData).then(()=>
      {
        Messenger.emitSuccess("Zaktualizowano produkt");
        [this.products, this.allProducts].forEach(collection => {
          let item = collection.find(item => item.id == this.id)
          item.name = postData.name
          item.description = postData.description
        })
        this.clear()
      }
      ).catch((e)=>{
        Messenger.emitError("Nie można zaktualizować produktu")
      })

    },
    prepareToUpdateProduct(item){
      this.id = item.id
      this.name = item.name
      this.description = item.description
      this.dialog = true

    },
    clear(){
      this.name = ''
      this.description = ''
      this.id = 0
    },
    search(text){
      if(text==""){
        this.products = this.allProducts
      }

      text = text.toLowerCase()
      this.products = this.allProducts.filter(product =>
          product.name.toLowerCase().includes(text) || product.description.toLowerCase().includes(text))
    },
    deleteProduct(id){
      this.$confirm("Jesteś pewien?").then(res=>{
        if(res){
          this.$http.delete('/storage/type/' + id).then(()=>{
            this.allProducts = this.allProducts.filter(el => el.id != id)
            this.products = this.allProducts
            Messenger.emitSuccess("Usunięto produkt");
          }).catch(()=>{
            Messenger.emitError("Nie można usunąć produktu")
          })
        }
      })
    }
  },
  created() {
    this.loading = true
    this.$http.get('/storage/types').then(data=>{
      this.products = data.data
      this.allProducts = data.data
      this.loading = false
    }).catch(()=>{
      Messenger.emitError("Nie można pobrać danych")
    })
  }
}
</script>

<style scoped>

</style>